const paramRegex = /(\w+)\s*=\s*(\{.*\}|\[.*\]|"[^"]*"|[^,]+)/g;
export function parseParams(params) {
    if (!params) {
        return undefined;
    }
    const result = {};
    let match = paramRegex.exec(params);
    while (match !== null) {
        const [, key, value] = match;
        result[key] = parseParamValue(value.trim());
        match = paramRegex.exec(params);
    }
    return result;
}
function parseParamValue(value) {
    if (value === 'true' || value === 'false') {
        return value === 'true';
    }
    if (!Number.isNaN(Number(value))) {
        return Number(value);
    }
    if (value.startsWith('"') && value.endsWith('"')) {
        return value.slice(1, -1);
    }
    if (value.startsWith('[') && value.endsWith(']')) {
        const arrayContent = value.slice(1, -1).trim();
        return parseArray(arrayContent);
    }
    if (value.startsWith('{') && value.endsWith('}')) {
        const objectContent = value.slice(1, -1).trim();
        return parseObject(objectContent);
    }
    return value;
}
function parseArray(arrayContent) {
    const result = [];
    let currentElement = '';
    let depth = 0;
    let isString = false;
    for (let i = 0; i < arrayContent.length; i++) {
        const char = arrayContent[i];
        if (char === ',' && depth === 0 && !isString) {
            result.push(parseParamValue(currentElement.trim()));
            currentElement = '';
        }
        else {
            currentElement += char;
            if (char === '"' && (i === 0 || arrayContent[i - 1] !== '\\')) {
                isString = !isString;
            }
            else if (!isString) {
                if (char === '[' || char === '{') {
                    depth++;
                }
                else if (char === ']' || char === '}') {
                    depth--;
                }
            }
        }
    }
    if (currentElement.trim() !== '') {
        result.push(parseParamValue(currentElement.trim()));
    }
    return result;
}
function parseObject(objectContent) {
    const result = {};
    let currentKey = '';
    let currentValue = '';
    let inKey = true;
    let depth = 0;
    let isString = false;
    for (let i = 0; i < objectContent.length; i++) {
        const char = objectContent[i];
        if (char === ':' && depth === 0 && !isString) {
            inKey = false;
        }
        else if (char === ',' && depth === 0 && !isString) {
            result[currentKey.trim()] = parseParamValue(currentValue.trim());
            currentKey = '';
            currentValue = '';
            inKey = true;
        }
        else {
            if (inKey) {
                currentKey += char;
            }
            else {
                currentValue += char;
                if (char === '"' && (i === 0 || objectContent[i - 1] !== '\\')) {
                    isString = !isString;
                }
                else if (!isString) {
                    if (char === '[' || char === '{') {
                        depth++;
                    }
                    else if (char === ']' || char === '}') {
                        depth--;
                    }
                }
            }
        }
    }
    if (currentKey.trim() !== '') {
        result[currentKey.trim()] = parseParamValue(currentValue.trim());
    }
    return result;
}
export function printStmtArguments(args) {
    if (!args)
        return undefined;
    return Object.entries(args)
        .map(([key, value]) => {
        if (typeof value === 'string') {
            return `${key}="${value}"`;
        }
        if (typeof value === 'number' || typeof value === 'boolean') {
            return `${key}=${value}`;
        }
        if (Array.isArray(value)) {
            const arrayValues = value
                .map(v => {
                if (typeof v === 'string') {
                    return `"${v}"`;
                }
                else if (typeof v === 'object' && v !== null) {
                    // Recursively print nested objects in arrays with colons
                    return `{${printObject(v)}}`;
                }
                return printObject(v) || v;
            })
                .join(', ');
            return `${key}=[${arrayValues}]`;
        }
        if (typeof value === 'object' && value !== null) {
            return `${key}={${printObject(value)}}`;
        }
        return `${key}=${value}`;
    })
        .join(', ');
}
function printObject(obj) {
    return Object.entries(obj)
        .map(([k, v]) => {
        if (typeof v === 'string') {
            return `${k}: "${v}"`;
        }
        if (typeof v === 'number' || typeof v === 'boolean') {
            return `${k}: ${v}`;
        }
        if (Array.isArray(v)) {
            const arrayValues = v
                .map(av => {
                if (typeof av === 'string') {
                    return `"${av}"`;
                }
                else if (typeof av === 'object' && av !== null) {
                    return `{${printObject(av)}}`;
                }
                return printObject(av) || av;
            })
                .join(', ');
            return `${k}: [${arrayValues}]`;
        }
        if (typeof v === 'object' && v !== null) {
            return `${k}: {${printObject(v)}}`;
        }
        return `${k}: ${v}`;
    })
        .join(', ');
}
//# sourceMappingURL=params.js.map